module.exports = "./img/edd0a0a81a7d6e96a5011362cf051342.jpg";